/**
 * vat-rate.ts — most między stawką VAT z kartoteki towarów a słownikiem `vat_rates`.
 *
 * Kartoteka `products` trzyma stawkę w formacie Symfonii jako string z `%`
 * (np. „23%", „8%") — patrz `products.vat_rate` (`varchar`). Słownik `vat_rates`
 * (generyczny mechanizm `dictionaries`) trzyma pozycje z KODEM bez `%` (np. „23",
 * „8", „zw", „np", „oo") i opcjonalną wartością liczbową w polu `value`.
 *
 * Przy wyborze towaru w gridzie pozycji kopiujemy jego stawkę jako MIGAWKĘ do
 * pozycji dokumentu (`vat_rate_code` + `vat_rate`) — ten helper normalizuje
 * surowy format towaru na kod słownika, żeby dopasować pozycję słownika i pobrać
 * jej wartość liczbową. Brak istniejącego parsera w repo (zweryfikowane).
 */

/**
 * Normalizuje surową stawkę VAT towaru na KOD pozycji słownika `vat_rates`.
 * Obcina `%` i białe znaki. „23%" → „23", „ 8 % " → „8", „zw" → „zw".
 * Zwraca pusty string dla braku wejścia (null/undefined/pusty).
 */
export function parseVatRateCode(raw: string | null | undefined): string {
  if (raw == null) return '';
  return raw.replace('%', '').trim();
}
